import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchPatientCaseLists } from '../../../utilities/API/caseServices';

export const patientCaseListDetails = createAsyncThunk(
    'patientCase/listsData', fetchPatientCaseLists
)


const initialState = {
    patientCaseList: [{
        "program": "--",
        "status": "--",
        "caseOwner": "--",
        "applicationID": "--",
        "caseID": "--",
        "einNumber": "--",
        "createdDateTime": "--"
    }],
    hasActiveCase: false,
    loader: false
}

const patientCaseListSlice = createSlice({
    name: 'patientCaseListData',
    initialState,

    reducers: {
        resetPatientCaseList: (state) => {
            state.patientCaseList = [{
                "program": "--",
                "status": "--",
                "caseOwner": "--",
                "applicationID": "--",
                "caseID": "--",
                "einNumber": "--",
                "createdDateTime": "--"
            }]
            state.hasActiveCase = false
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(patientCaseListDetails.pending, (state, action) => {
                state.loader = true
            })
            .addCase(patientCaseListDetails.fulfilled, (state, action) => {
                state.loader = false
                const arr = []
                if (action.payload.status == "SUCCESS" && action?.payload?.data?.length > 0) {
                    action?.payload?.data?.map((data) => {
                        arr.push({
                            "program": "Case Management",
                            "status": data?.status || "--",
                            "caseOwner": data?.caseowner || "--",
                            "caseID": data?.caseid || "--",
                            "applicationID": data?.casenumber || "--",
                            "createdDateTime": data?.createddate || "--",
                            "einNumber": data?.einnumber || "--"
                        })
                    })
                    state.hasActiveCase = action.payload.hasactivecase
                    state.patientCaseList = arr
                    state.hasCases = true
                }
            })
            .addCase(patientCaseListDetails.rejected, (state, action) => {
                state.loader = false
            })
    },
})

export const { resetPatientCaseList } = patientCaseListSlice.actions;

export default patientCaseListSlice.reducer
